import {
  Avatar,
  InteractiveContainer,
} from "@jugl-web/ui-components/cross-platform";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export type ListItemCardProps = {
  title: string;
  subTitle?: ReactNode | string;
  avatarSrc?: string | null;
  subAvatarSrc?: string | null;
  subAvatarEl?: ReactNode;
  subAvatarTitle?: string | null;
  rightContent?: ReactNode;
  className?: string;
  onClick?: () => void;
};

export const ListItemCard: FC<ListItemCardProps> = ({
  title,
  subTitle,
  avatarSrc,
  subAvatarSrc,
  subAvatarEl,
  subAvatarTitle,
  rightContent,
  className,
  onClick,
}) => (
  <InteractiveContainer
    className={cx(
      "flex items-center gap-4 rounded-2xl bg-[#F9F9FA] px-[18px] py-3 transition-colors",
      { "hover:bg-[#F5F5F8]": !!onClick },
      className
    )}
    isDisabled={!onClick}
    onClick={onClick}
  >
    <div className="relative h-[48px] w-[48px]">
      <Avatar username={title} size="lg" imageUrl={avatarSrc} />
      {subAvatarEl && (
        <div className="absolute bottom-[-8px] right-[-5px]">{subAvatarEl}</div>
      )}
      {(subAvatarSrc || subAvatarTitle) && (
        <div className="absolute bottom-[-8px] right-0">
          <Avatar
            username={subAvatarTitle || ""}
            size="xs"
            className="h-[20px] w-[20px] border-[2px] border-solid border-white"
            imageUrl={subAvatarSrc}
          />
        </div>
      )}
    </div>
    <div className="min-w-0 flex-1">
      <div className="truncate font-medium leading-4">{title}</div>
      {subTitle && (
        <div
          className="leading-2 truncate text-xs text-[#707577]"
          title={typeof subTitle === "string" ? subTitle : undefined}
        >
          {subTitle}
        </div>
      )}
    </div>
    {!!rightContent && <div>{rightContent}</div>}
  </InteractiveContainer>
);
